/**
 * assets/lp-cta-tracking.js
 * Pushes an lp_navigation_click event to the GTM dataLayer when a tagged landing-page CTA is
 * clicked. A CTA opts in by carrying data-lp-cta and the ids the event needs; anything
 * untagged is ignored, so sections can be wired up one at a time.
 *
 * lp_name is read from the nearest ancestor carrying data-lp-name, so a section declares it
 * once on its wrapper and every CTA inside inherits it.
 *
 * interaction_type defaults to link_click and can be overridden per CTA with
 * data-interaction-type, for in-page jump links that scroll rather than navigate.
 *
 * Safe to include from more than one section: only the first copy binds a listener.
 */
(function () {
  if (window.lpCtaTrackingReady) return;
  window.lpCtaTrackingReady = true;

  var DEFAULT_INTERACTION = 'link_click';

  // Delegated from the document rather than bound per CTA, so links keep reporting after the
  // theme editor re-renders a section and there is nothing to re-bind.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var cta = target.closest('[data-lp-cta]');
    if (!cta) return;

    var scope = cta.closest('[data-lp-name]');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'lp_navigation_click',
      lp_name: (scope && scope.getAttribute('data-lp-name')) || '',
      content_id: cta.getAttribute('data-content-id') || '',
      content_type: cta.getAttribute('data-content-type') || '',
      interaction_type: cta.getAttribute('data-interaction-type') || DEFAULT_INTERACTION,
      // href resolves to an absolute URL; the label is collapsed because the markup indents it
      // onto its own line, and any icon inside is alt="" so it contributes nothing.
      link_url: cta.href || '',
      link_text: (cta.textContent || '').replace(/\s+/g, ' ').trim()
    });
  });
})();
